import { render } from "./MvCol1.vue?vue&type=template&id=da01ec78"
import script from "./MvCol1.vue?vue&type=script&lang=js"
export * from "./MvCol1.vue?vue&type=script&lang=js"

import exportComponent from "/Users/kadowakikiyomi/Documents/PEARLY_GATES/CATALOGUE/PG/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__